module.exports = __webpack_public_path__ + "static/oblakoder-paralexa-home-b3f265b66ec5e845dfbe1e6946f116de.jpg";